import notFoundImg from '../../assets/img/notfound.png';

const NotFound = () => {
    return (
        <div className="container">
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="row">
                    <div className="col">
                        <img className="mx-auto d-block" style={{ height: 200, width: 'auto' }} src={notFoundImg} alt="You are Offline" />
                        <p className="text-center mt-3">Stop there buddy, you&apos;re lost.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
